<template>
    <div v-loading="loading">
        <div>
            <span tkey="區號">{{i18n.tkey("lang_area_num")}}&nbsp;</span>
            <el-select
                v-model="regionNum"
                :placeholder="i18n.tkey('lang_area_num')"
                size="large"
                @change="changeRegionNum"
            >
                <el-option
                    v-for="n in 99"
                    :key="n"
                    :label="n"
                    :value="n"
                />
            </el-select>
        </div>

        <div style="background-color:#6a84b3">
            <IslandOption
                v-for="(v, i) in dataList"
                :obj="v"
                :key="v.id"
                @clickOption="clickCallback"
            />
        </div>

    </div>
</template>

<script setup>

import {inject, ref, onBeforeMount, getCurrentInstance, toRef} from "vue";
import record14Api from "@/request/record14Api";
import myUtil from "@/util/util";
import IslandOption from "@/components/Shopopee3D/ui/islandOption.vue";
import {useUserinfo} from "@/stores/userinfo";

const props = defineProps(["autoJump", "saveRegionNum"])
const emits = defineEmits(["selectCallback"])

const i18n = inject("i18n")
const loading = ref(false)

const dataList = ref([])
const regionNum = ref(1)

const userInfoRef = toRef(useUserinfo())
const { proxy } = getCurrentInstance()

const reload = inject("reload");

function getIslandList(){
    loading.value = true

    const request = record14Api.getIslandInfoList
    const params = request.getParams()

    params.recordno = -1
    params.addinfo17 = "-1"

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            let list = res.detail

            for (let i=0; i<list.length; i++){
                const obj = list[i]

                if (obj.companycode === "ZZ"){
                    const temp = list[0]
                    list[0] = obj
                    list[i] = temp
                    break;
                }

            }

            dataList.value = res.detail
        }else{
            myUtil.alertError(res.msg)
        }

    })

}

function clickCallback(obj){
    if (props.autoJump !== false){
        myUtil.confirmWarning(i18n.tkey("lang_select_region_confirm") + `?` , () => {
            userInfoRef.value.currPage = regionNum.value

            if (obj.companycode == "ZZ"){
                proxy.$router.push({path: `/index`})
            }else{
                proxy.$router.push({path: `/${obj.id}/index`})
            }

            if (proxy.$route.path.indexOf("/index") != -1){
                reload()
            }
        })
    }else{
        userInfoRef.value.currPage = regionNum.value
        emits("selectCallback", obj, regionNum.value)
    }

}

function getRegionNum(){
    return regionNum.value
}

function changeRegionNum(){
    if (props.saveRegionNum === true){
        userInfoRef.value.currPage = regionNum.value
    }
}

defineExpose({
    getRegionNum
})

onBeforeMount(() => {
    getIslandList()
})

</script>

<style scoped>



</style>